<template>
  <div class="content">
    <h5>即将跳转到小程序</h5>
    <h5>{{ urllink }}</h5>
    <el-button>
      <a :href="urllink">点我跳转</a>
    </el-button>
  </div>
</template>

<script>
export default {
  name: "Link",
  data() {
    return {
      url: "", // 局部
      urllink: "", // 全部
    };
  },
  mounted() {
    this.url = this.$route.params.url;
    this.urllink = "https://wxaurl.cn/" + this.url;
    location.href = this.urllink;
  },
};
</script>

<style scoped>
.content {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  text-align: center;
  padding-top: 200px;
}

h5 {
  padding-bottom: 20px;
}
</style>
